import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import Modal from '~/components/Modal';
import RadioOption from '~/components/RadioOption';
import TextInput from '~/components/TextInput';
import DurationInput from '~/components/DurationInput';
import CollapsiblePanel from '~/components/CollapsiblePanel.jsx';
import OptionToggle from '~/components/OptionToggle';

const AvailabilitySettings = ({
    settings,
    setSettings,
    onSave,
    defaultCapacity,
}) => {
    const [isShowing, setIsShowing] = useState(false);

    const isAutoStartTimes = !settings?.startInterval;

    return (
        <div>
            <div className="text-right -mt-6">
                <button
                    type="button"
                    className="text-gray-500 hover:text-gray-600 w-5 h-5"
                    onClick={() => setIsShowing(true)}
                >
                    <Cog6ToothIcon />
                </button>
            </div>

            <Modal isOpen={isShowing} onClose={() => setIsShowing(false)}>
                <h2>Availability Settings</h2>
                <div>
                    <RadioOption
                        checked={isAutoStartTimes}
                        onChange={() => {
                            setSettings({ startInterval: null });
                        }}
                        label="Show start times based on event durations"
                        description="Start times shown to clients will be determined based on event durations to fit in the most appointments (recommended)"
                    />
                    <RadioOption
                        checked={!isAutoStartTimes}
                        onChange={() => {
                            setSettings({ startInterval: 30 });
                        }}
                        label="Set specific start time interval"
                        description="Show start times at an interval you specify during your available hours"
                    />
                    {!isAutoStartTimes && (
                        <div>
                            <DurationInput
                                label="Show start times every"
                                value={settings?.startInterval}
                                autoFocus={true}
                                className="max-w-48 ml-6"
                                onChange={newValue =>
                                    setSettings({ startInterval: newValue })
                                }
                            />
                        </div>
                    )}

                    <CollapsiblePanel
                        title="Advanced"
                        initialOpen={!!settings?.capacity}
                        className="mt-4"
                    >
                        <div className="p-4">
                            <TextInput
                                label={
                                    settings?.capacity > 1
                                        ? `Allow double booking up to ${settings?.capacity} appointments at one time`
                                        : 'Number of appointments at one time'
                                }
                                value={settings?.capacity}
                                onChange={newValue =>
                                    setSettings({
                                        ...settings,
                                        capacity: newValue,
                                    })
                                }
                                placeholder={`Defaults to ${defaultCapacity}`}
                            />
                        </div>
                        <div className="p-4 pt-0">
                            <OptionToggle
                                title="Allow other availability groups to overlap"
                                description="By default, an appointment booked under a different availability group blocks off all slots at that time on other groups. Enable this to have each appointment only block off one slot for each group."
                                value={!!settings?.disableBlockingOtherGroups}
                                onChange={newValue =>
                                    setSettings({
                                        ...settings,
                                        disableBlockingOtherGroups: newValue,
                                    })
                                }
                            />
                        </div>
                    </CollapsiblePanel>
                </div>
                <button
                    type="button"
                    className="btn-save mt-4"
                    onClick={() => {
                        setIsShowing(false);
                        onSave();
                    }}
                >
                    Save
                </button>
            </Modal>
        </div>
    );
};

export default AvailabilitySettings;
